import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import TextField from '@mui/material/TextField';


const CheckoutBlock = ({ cartData }) => {

    const [coupon, setCoupon] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault()
        toggleDrawer('right', false)
        console.log(coupon)
    }
    const [state, setState] = useState({
        right: false,
    });
    let total = cartData?.reduce((total, prd) => total + (parseInt(prd?.price) * prd?.orderQuantity), 0)

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const navigate = useNavigate();
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setCoupon(e.target.value)
            alert('Thank you! We received your coupon code.')
            navigate('/success')
        }
    }


    const list = (anchor) => (
        <Box
            sx={{ width: 250 }}
            role="presentation"
        // onClick={toggleDrawer(anchor, false)}

        >
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    '& > :not(style)': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                onKeyDown={toggleDrawer(anchor, true)}
                onClick={toggleDrawer(anchor, true)}
            >
                <TextField onKeyPress={handleKeyPress} required id="outlined-basic" label="Enter Coupon Code" variant="outlined" />
            </Box>
            {/* <Divider /> */}
        </Box>
    );
    return (
        <>
            <div className='review-product-cart'>
                <div className="row">
                    <div className="col-12">
                        <div className="card" >
                            <div className="card-body">
                                {['right'].map((anchor) => (
                                    <React.Fragment key={anchor}>
                                        <button className='btn w-100' disabled={cartData?.length > 0 ? false : true} onClick={toggleDrawer(anchor, true)}>Apply Coupon</button>
                                        <Drawer
                                            anchor={anchor}
                                            open={state[anchor]}
                                            onClose={toggleDrawer(anchor, false)}
                                        >
                                            {list(anchor)}
                                        </Drawer>
                                    </React.Fragment>
                                ))}
                                {/* <button className='btn w-100'>Apply Coupon</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='review-product-cart'>
                <div className="row">
                    <div className="col-9 col-sm-8">
                        <p className='total-item'>Item(s) Total</p>
                        <small className='approx' >Approx. Delivery Charge</small>
                    </div>
                    <div className="col-3 col-sm-4 text-end">
                        <p className='m-0 subtotal-price' style={{ color: 'gray' }}>৳{total || 0}</p>
                        <small className='font-weight-bolder' style={{ color: '#3a8438' }}>Free</small>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-9 col-sm-8">
                        <p className='m-0 payable-amount' style={{ marginBottom: '5px', fontWeight: 'bolder' }}>Amount Payable</p>
                    </div>
                    <div className="col-3 col-sm-4 text-end">
                        <p className='m-0 payable-price' style={{ fontWeight: 'bolder' }}>৳{total || 0}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <small className='font-weight-bolder price-may-be-change'>Prices may change based on shipping address</small>
                    </div>
                </div>
                {
                    window.location.pathname === '/checkout' ? '' : <div className="row checkout-block">
                        <div className="col-12">
                            <div className="card" >
                                <div className="card-body checkout">
                                    {
                                        cartData?.length > 0 ? <Link to='/checkout'>
                                            <button className='btn w-100'>CHECKOUT</button>
                                        </Link> : <button className='btn w-100' disabled={cartData?.length > 0 ? false : true}>CHECKOUT</button>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </>
    );
};

export default CheckoutBlock;